import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SearchableList from "../../Generic/Algolia/SearchableList";
import { MDBBtn, MDBIcon } from "mdbreact";
import { selectBranch, updateBranchDetails } from "../../../actions/customersActions";
import AddFAB from "../../Generic/Images/AddFab.png";
import config from "../../../config";

class BranchList extends Component {


  
  HitComponent = ({ hit }) => {
    const listItemClickHandler = () => {
      this.props.dispatch(updateBranchDetails(hit.details));
      this.props.dispatch(selectBranch(hit.objectID));
      this.props.history.push(`/customers/${hit.customerId}/projects/bid/${hit.objectID}`);
    };

    let className = "";
    if (this.props.id === hit.objectID) {
      className = { className: "selected" };
    }

    return (
      <Fragment>
        <p {...className} onClick={listItemClickHandler}>
          <strong>{hit.details.name}</strong>
          <br />
          {hit.details.addressType}
          <br />
          {hit.details.address.streetName ? `${hit.details.address.streetNumber} ` : ""}
          {hit.details.address.streetName ? hit.details.address.streetName : "No Street Address"}
          {hit.details.address.city ? `, ${hit.details.address.city}` : ""}
          {hit.details.address.state} {hit.details.address.postcode}
          <br />
        </p>
        {className.className === "selected" ? (
          <Fragment>
            <MDBBtn
              onClick={() => {
                this.props.history.push(
                  `/customers/${hit.customerId}/branches/${hit.objectID}/edit`
                );
              }}
              color="blue"
              id="brEditBtn"
            >
              Edit
            </MDBBtn>
            <MDBBtn
              onClick={() => {
                this.props.history.push(
                  `/customers/${hit.customerId}/branches/${hit.objectID}/delete`
                );
              }}
              color="red"
              id="brDeleteBtn"
            >
              <MDBIcon icon="trash" />
            </MDBBtn>
          </Fragment>
        ) : (
          ""
        )}
      </Fragment>
    );
  };

  render() {
    return (
      <div className="branch-container">
        <div className="branch-header">
          <h6>Branch List</h6>
        </div>
        <div className="branch-list">
          <SearchableList
            appId={`${config.algolia.appId}`}
            index={`${config.algolia.prefix}customers_branches_name_asc`}
            hitComponent={this.HitComponent}
            selectedObjectId={this.props.id}
            filters={`isDeleted:false AND customerId:${this.props.match.params.customerId}`}
          />
          <img
            className={"fabButton"}
            id="addBranchPlusBtn"
            alt="Add"
            src={AddFAB}
            onClick={() =>
              this.props.history.push(
                `/customers/${this.props.match.params.customerId}/branches/add`
              )
            }
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return state.customers.branch;
};

export default withRouter(connect(mapStateToProps)(BranchList));
